import BaseTransformer from "./base.transformer"
export const baseUri = "/api/billing-infos"
class BillingInfoTransformer extends BaseTransformer {
  static fetch(billingInfo) {
    const uuid = this.transformUuid(billingInfo)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      name: billingInfo.name,
      legalId: billingInfo.legalId,
      city: billingInfo.city,
      state: billingInfo.state,
      country: billingInfo.country,
      postalCode: billingInfo.postalCode,
      addressLine1: billingInfo.addressLine1,
      addressLine2: billingInfo.addressLine2,
      email: billingInfo.email,
      account: billingInfo.account,
      createdAt: billingInfo.createdAt,
      updatedAt: billingInfo.updatedAt,
      isValid: Boolean(
        billingInfo.name?.length > 0 &&
          billingInfo.email?.length > 0 &&
          billingInfo.addressLine1?.length > 0 &&
          billingInfo.city?.length > 0 &&
          billingInfo.postalCode?.length > 0 &&
          billingInfo.country?.length > 0
      )
    })
  }
}

export default BillingInfoTransformer
